
<div class="img-zoom-container clearfix" [ngStyle]="{'width' : imgWidth + 'px'}">
  <img #img [style.width]="yet && imgWidth?imgWidth+'px':null" [style.height]="yet && imgHeight?imgHeight+'px':null"
  class="image-zoom" [src]="imagen" (load)="onLoad()">
  <div #len [style.width]="lenSize+'px'" [style.height]="lenSize+'px'"  [style.left] ="posX+'px'" [style.top] ="posY+'px'" class="img-zoom-lens">
</div>